<template>
  <div>
    <el-input v-model="filterText" :clearable="true"></el-input>
    <el-tree
      :data="treeData"
      :props="defaultProps"
      node-key="id"
      :show-checkbox="checkable"
      highlight-current
      :filter-node-method="filterNode"
      :default-expanded-keys="defaultExpanded"
      @show="clearFilter"
      @check-change="changeTree"
      @node-click="changeCurrent"
      :check-strictly="selectHQ"
      ref="tree">
    </el-tree>
  </div>
</template>

<script>
  import _ from 'lodash';
  import {getAgencyTree} from '@/service/api';

  export default {
    data () {
      return {
        checkable: this.$attrs.checkable === undefined || this.$attrs.checkable,
        storeOnly: this.$attrs.storeOnly,
        disabledHQ:this.$attrs.disabledHQ,//用来控制总店是否可以勾选
        selectHQ: this.$attrs.selectHQ,   //用来控制是否可以单独勾选总店
        filterLeaf: this.$attrs.filterLeaf,  // 过滤机构树只显示总部和分公司
        filterStore: this.$attrs.filterStore,//过滤机构树不显示分公司
        filterText: '',
        currentKeys: [],
        treeData: [],
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        disabledHotelIdList: [],
        defaultExpanded: [],
        allNodes: {}
      };
    },
    created () {
      getAgencyTree().then(agencyTree => {
        agencyTree.map(node => {
          if (node.hotelId) {
            this.allNodes[node.hotelId] = node.id;
          }
        });
        this.initTree(agencyTree);
      });
    },
    methods: {
      initTree (agencyList) {
        let _this = this,
            _root = agencyList.shift();
        agencyList.forEach(agencyItem => {
          this.disabledHotelIdList.forEach(disabledId => {
            if (agencyItem.hotelId === disabledId) {
              agencyItem.disabled = true;
            }
          });
        });
        if (_this.filterLeaf) {
          agencyList = _.filter(agencyList, {type: 2});
        }
        if (_this.filterStore){
          agencyList = _.filter(agencyList, function (o){return o.type !==4;});
        }
        _root.children = _this.findChild(agencyList, _root.id);
        // _root.children = _.filter(_root.children,function (o){return o.type !==4;});
        _this.treeData = [_root];
        _this.defaultExpanded = [_this.treeData[0].id] || [];
      },
      findChild (list, pid) {
        let _this = this,
        	  arr = [];
        list.map(item => {
          if (item.pid === pid) {
            item.children = _this.findChild(list, item.id);
            // 只显示门店的情况下，去除非门店/单店的叶子节点
            if (item.children.length || !_this.storeOnly || item.type === 3 || item.type === 6) {
              arr.push(item);
            }
          }
        });
        arr.map(item => {
          _.pull(list, item);
        });
        return arr;
      },
      clearFilter () {
        this.filterText = '';
      },
      filterNode (value, data) {
        if (!value) {
          return true;
        }
        return data.name.indexOf(value) !== -1;
      },
      changeTree () {
        let checkedNodes = this.$refs.tree.getCheckedNodes(),
            leafNodes = checkedNodes.filter(node => node.children && node.children.length === 0);
        this.currentKeys = leafNodes;
        this.$emit('checkAgencyLeavesCore', leafNodes);
        this.$emit('checkAgenciesCore', checkedNodes);
      },
      changeCurrent (data) {
        if (!this.checkable) {
          this.$emit('selectTreeAgency', data);
        }
      },
      setAgency (agencies, useHotelId = false) {
        if (useHotelId) {
          agencies = agencies.map(hotelId => {
            return this.allNodes[hotelId] || hotelId;
          });
        }
        setTimeout(() => {//checkable false为单选
          if (this.checkable) {
            agencies = agencies || [];
            this.$refs.tree.setCheckedKeys(agencies);
          } else {
            if (agencies === undefined) {
              this.$emit('selectTreeAgency');
              this.$refs.tree.store.currentNode = null;
            } else {
              let curNode = this.$refs.tree.store.nodesMap[agencies].data;
              this.$emit('selectTreeAgency', curNode);
            }
          }
        }, 0);
      },
      pickUp () {
        // 收起全部节点
        let allNode = this.$refs.tree.store._getAllNodes();
        allNode.forEach(node => {
          node.expanded = false;
        });
      },
      setDisabled (list = []) {
        this.disabledHotelIdList = list;
        if (this.treeData) {
          getAgencyTree().then(agencyTree => {
            this.initTree(agencyTree);
          });
        }
      }
    },
    watch: {
      filterText (val) {
        this.$refs.tree.filter(val);
      },
    }
  };
</script>

<style lang="less">
  .el-tree {
    overflow: auto;
    max-height: 300px;
  }
</style>



// WEBPACK FOOTER //
// AgencyTreeCore.vue?fcb88d22